import "./polyfills";
import "@/apps/index.css";
import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import VueVirtualScroller from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

import App from "./App.vue";
import router from "@/apps/routers";
import { VueQueryPlugin } from "@tanstack/vue-query";
import withUUID from "vue-uuid";

// shared
import datePickerPlugin from "@/shared/libs/plugins/date-picker";
import vueDraggablePlusPlugin from "@/shared/libs/plugins/vue-draggable-plus";
import libsRegisterInit from "@/shared/libs/LibsRegister";

// stores
import stateRegisterInit from "@/shared/libs/stores/server/StateRegister";
import clientManagerRegisterInit from "@/shared/libs/stores/client/StateRegister";
import clientStateRegisterInit from "@/shared/model/store/register";
import appsServices from "@/apps/services";

// features
import { registerCurriculumProviders } from "@/features/curriculum/lib/providers";
import { registerAcademyProviders } from "@/features/academy/lib/providers";

// entities
import { behaviorRegisterInit } from "@/entities/behaviorRegister";
import repositoriesRegisterInit from "@/entities/repositoriesRegister";

// utils
import clickOutside from "@/shared/directives/clickOutside";
import popupManagerPlugin from "@/shared/plugins/PopupManager";

const prepareMsw = async () => {
    if (import.meta.env.DEV && import.meta.env.VITE_MSW_TEST === "true") {
        const { worker } = await import("../shared/libs/msw/browser");
        return worker.start({ onUnhandledRequest: "bypass" });
    }
};
// 먼저 repository 를 등록해야, 이후 pinia 내에서 container 내 접근이 가능합니다.
behaviorRegisterInit();
repositoriesRegisterInit();
libsRegisterInit();
appsServices();

const app = withUUID(createApp(App));
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

app.use(pinia);
app.use(router);
app.use(VueVirtualScroller);

app.use(datePickerPlugin);
app.use(vueDraggablePlusPlugin);
app.directive("click-outside", clickOutside);
app.use(popupManagerPlugin);

// 의존성을 주입합니다.

stateRegisterInit();
clientManagerRegisterInit();

clientStateRegisterInit();

// Register feature providers
registerCurriculumProviders();
registerAcademyProviders();

app.use(VueQueryPlugin, {
    queryClientConfig: {
        defaultOptions: {
            queries: {
                staleTime: 1000 * 60,
                gcTime: 1000 * 60 * 10,
                refetchOnReconnect: true,
                throwOnError: false,
            },
            mutations: {
                retry: 0,
                throwOnError: false,
            },
        },
    },
});

prepareMsw().then(() => {
    console.log("MSW is ready");
    app.mount("#app");
});
